import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { useForm } from '@uhg-abyss/web/hooks/useForm';

export const ByRequestId = ({ id, inputModel, inputLabel, ...props }) => {
  const MIN_LENGTH = 8;
  const MAX_LENGTH = 23;
  const isRequestIDInValid = (value) => {
    return (
      (value.match(new RegExp('u', 'g')) || []).length > 1 ||
      (value.match(new RegExp('U', 'g')) || []).length > 1 ||
      (value.match(new RegExp('P', 'g')) || []).length > 1 ||
      (value.match(new RegExp('p', 'g')) || []).length > 1 ||
      (value.match(new RegExp('-', 'g')) || []).length > 1
    );
  };

  const form = useForm();
  useEffect(() => {
    form.setValue(inputModel, '');
  }, []);

  return (
    <React.Fragment>
      <TextInput
        {...props}
        id={inputLabel}
        label="Request ID"
        subText="Example: UP-12345"
        aria-label="type here to enter a request id "
        maxLength={10}
        validators={{
          required: 'Please enter a valid Request ID.',
          validate: {
            isValidRequestId: (value) => {
              return (
                !(
                  value.length < MIN_LENGTH ||
                  value.length > MAX_LENGTH ||
                  !value.toUpperCase().startsWith('UP-') ||
                  isRequestIDInValid(value)
                ) || 'Request ID is invalid.'
              );
            },
          },
        }}
        formatter={(value) => {
          return value.replace(
            /(?![upUP])[!@#$%^&*)({}<>,.[\]+_`~=\\|';":/?A-Za-z]/g,
            ''
          );
        }}
        isClearable
        autoComplete="off"
        model={inputModel}
      />
    </React.Fragment>
  );
};

ByRequestId.propTypes = {
  inputModel: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
};

ByRequestId.defaultProps = {};
